/* eslint-disable no-undef */
const { logDebugging, logError, setUpLogger } = require('./log/logger');
const { default: CommonParams } = require('./trackings/params/commonparams');
const {
  TYPECONTENT,
  CONSUMER_BASE_URL,
  TRACKING_CONSUMER,
} = require('./trackings/constants/TrackingConstants');
const { default: Trackings } = require('./trackings/Trackings');
const { default: AdParams } = require('./trackings/params/adparams');
const { default: ContentParams } = require('./trackings/params/contentparams');
const { default: ContentCommonParams } = require('./trackings/params/contentcommonparams');
const { default: ConsumerParams } = require('./trackings/params/consumerParams');
const { getParametersFromUrl, setParametersToUrl } = require('./utils/urlUtils').default;

module.exports = {
  init(customerId, typeContent = TYPECONTENT.AD) {
    try {
      // eslint-disable-next-line no-undef
      window.tappxTracker = window.tappxTracker || [];
      const parameters = getParametersFromUrl(window.location.search);
      if (parameters) {
        setUpLogger({
          debug: parameters.jstappxdebug,
        });
      }
      logDebugging(`customerId ${customerId}`);
      const trackId = `trk-${parseInt(Math.random() * 10000, 10)}-${new Date().getTime()}`;
      window.tappxTracker[trackId] = new Trackings(typeContent, customerId);
      return trackId;
    } catch (error) {
      logError(error);
      return null;
    }
  },
  clientTrack(response, reqDuration, sizes, trackerID, initime) {
    if (!window.tappxTracker[trackerID]) {
      logError('TappxTracker was not initialized');
      return;
    }
    const baseUrl = `${CONSUMER_BASE_URL}/${TRACKING_CONSUMER}?`;
    const ClientTarcker = window.tappxTracker[trackerID];
    const frequency = ClientTarcker.getFrequency(response, reqDuration);
    const { msg, hash, customerId } = ClientTarcker;
    const commonParams = new ConsumerParams(reqDuration, sizes, msg, hash, customerId, initime);
    const urlParams = commonParams.build();
    url = setParametersToUrl(baseUrl, urlParams);
    ClientTarcker.sendToCLient(url, frequency);
  },
  setComonParams(mediationT, exInfo, sdkVersion, trackId) {
    logDebugging(mediationT, exInfo, sdkVersion);

    if (!window.tappxTracker[trackId]) {
      logError('TappxTracker was not initialized');
      return;
    }

    try {
      const commonParams = new CommonParams(mediationT, exInfo, sdkVersion);
      window.tappxTracker[trackId].setComonParams(commonParams);
    } catch (error) {
      logError(error);
    }
  },

  setCommonContentParams(data, trackId) {
    logDebugging(data);

    if (!window.tappxTracker[trackId]) {
      logError('TappxTracker was not initialized');
      return;
    }

    try {
      const commonContentParams = new ContentCommonParams(data);
      window.tappxTracker[trackId].setCommonContentParams(commonContentParams);
    } catch (error) {
      logError(error);
    }
  },

  setAdParams(adDataParams, trackId) {
    logDebugging(adDataParams);
    if (!window.tappxTracker[trackId]) {
      logError('TappxTracker was not initialized');
      return;
    }
    try {
      const adParams = new AdParams(adDataParams);
      window.tappxTracker[trackId].setAdParams(adParams);
    } catch (error) {
      logError(error);
    }
  },

  setContentParams(contentDataParams, trackId) {
    logDebugging(contentDataParams);
    if (!window.tappxTracker[trackId]) {
      logError('TappxTracker was not initialized');
      return;
    }
    try {
      const contentParams = new ContentParams(contentDataParams);
      window.tappxTracker[trackId].setContentParams(contentParams);
    } catch (error) {
      logError(error);
    }
  },

  send(eventStatus, impressionType, trackId) {
    logDebugging(eventStatus, impressionType);
    if (!window.tappxTracker[trackId]) {
      logError('TappxTracker was not initialized');
      return;
    }
    try {
      window.tappxTracker[trackId].send(eventStatus, impressionType);
    } catch (error) {
      logError(error);
    }
  },

  getUrlTracking(eventStatus, impressionType, trackId) {
    logDebugging(eventStatus, impressionType);
    if (!window.tappxTracker[trackId]) {
      logError('TappxTracker was not initialized');
      return null;
    }

    try {
      return window.tappxTracker[trackId].getUrlTracking(eventStatus, impressionType);
    } catch (error) {
      logError(error);
      return null;
    }
  },

  EVENT_STATUS: {
    REQUEST_DEMAND: 'REQUEST_DEMAND',
    DELIVERY: 'DELIVERY',
    IMPRESSION: 'IMPRESSION',
    ERROR: 'ERROR',
    REQUEST: 'REQUEST',
    DELIVERY_WINNER: 'DELIVERY_WINNER',
    DELIVERY_EMPTY: 'DELIVERY_EMPTY',
    BAD_REQUEST: 'BAD_REQUEST',
    WINNER_EMPTY: 'WINNER_EMPTY',
    PLAYER_LOADED: 'PLAYER_LOADED',
    VIEWABILITY: 'VIEWABILITY',
    REQUEST_PUBLISHER: 'REQUEST_PUBLISHER',
    CONTENT_VIEW: 'CONTENT_VIEW',
  },

  IMPRESSION_TYPE: {
    DISPLAY_PRE: 'PRE',
    DISPLAY_POST: 'POST',
    CLICK: 'CLICK',
    IMPRESSION: '0',
    START: '1',
    FIRSTQUARTILE: '25',
    MIDPOINT: '50',
    THIRDQUARTILE: '75',
    COMPLETE: '100',
  },

  CONTENT_TYPE: {
    AD: 'AD',
    CONTENT: 'CONTENT',
  },
};
